import { educationZ } from '@/components/dashboard/members/profile/types'
import {
  AddEducationDocument,
  Education,
} from '@/types/graphql/types'
import { getErrorMessage } from '@/util/getErrorMessage'
import { on } from '@/util/zodUtil'
import { useMutation } from '@apollo/client'
import { useForm } from '@mantine/form'
import { useModals } from '@mantine/modals'
import { showNotification } from '@mantine/notifications'
import { parseInt, toString } from 'lodash'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const useEducationForm = ({
    education,
    handleUpdateEducations,
  }: {
    education: Education | null
    handleUpdateEducations: ({
      newEducations,
    }: {
      newEducations: Education[]
    }) => void
  }) => {
    const { t } = useTranslation('common')
    const { query } = useRouter()
    const modals = useModals()
  
    const form = useForm({
      initialValues: {
        university: education?.university ?? '',
        graduationYear: education?.graduationYear
          ? new Date(education?.graduationYear)
          : '',
        profession: toString(education?.profession?.id) ?? '',
        specialty: toString(education?.specialty?.id) ?? '',
        qualification: toString(education?.qualification?.id) ?? '',
      },
    })
  // add education mutation
    const [mutateEducation, { loading }] = useMutation(AddEducationDocument, {
      onCompleted(data) {
        handleUpdateEducations({
          newEducations: data.addEducation as Education[],
        })
        modals.closeAll()
        showNotification({
          title: t('updated'),
          message: t('updatedSuccessfully'),
        })
      },
      onError(error) {
        showNotification({
          title: t('error'),
          message: getErrorMessage(error),
          color: 'red',
          autoClose: false,
        })
      },
    })
  //submit education data
    const submit = (values: typeof form.values) => {
      const zod = educationZ(on('create')).safeParse(values)
      if (zod.success) {
        if (education === null) {
          // create
          mutateEducation({
            variables: {
              data: {
                education: zod.data,
                userId: parseInt(query.id as string),
              },
            },
          })
        } else {
          // update
          mutateEducation({
            variables: {
              data: {
                education: zod.data,
                userId: parseInt(query.id as string),
                educationId: education.id,
              },
            },
          })
        }
      }
    }
    return {
      form,
      submit,
      loading,
    }
  }

export default useEducationForm